import MobileNavigation from './includes/MobileNavigation';
import SubNavigation from './includes/SubNavigation';

new SubNavigation();
new MobileNavigation();

document.querySelector( '.print-button' )?.addEventListener( 'click', () => {
	window.print();
} );

document.querySelectorAll( '.campaign-planner details summary' ).forEach( ( summary ) =>
	summary.addEventListener( 'click', ( e ) => {
		if ( summary.parentElement?.hasAttribute( 'open' ) ) {
			e.preventDefault();
		}
	} )
);
